/* eslint-disable react/jsx-key */
import React, { useMemo, useState } from 'react'
import { dateCol, strCol } from '@integec/grid-tools/lib/cols'

import {
  getApiTargetInfo,
  getUnitNameMap,
  getUtilityNameMap,
  UtilityUnitSelection,
} from 'core'
import {
  modifierCol,
  modifiedDateCol,
  unitIdHeader,
  utilityReqHeader,
} from 'core/HeaderColTypeProps'
import { connect } from 'react-redux'
import moment from 'moment'

import CommonScreen from '../CommonScreen'
import { Button, DatePicker, Input } from 'antd'
import {
  deleteUnitBlock,
  getUnitBlock,
  updateUnitBlock,
} from '../../../api/pgads'
import { Label } from '../../../core/screen-util'

const headers = [
  utilityReqHeader,
  unitIdHeader,
  strCol({
    ident: 'blockId',
    display: 'Block Id',
    width: 150,
    sortOrder: 'asc',
    isKey: true,
  }),
  dateCol({
    ident: 'effectiveFrom',
    display: 'Effective From',
    sortOrder: 'asc',
    isKey: true,
    width: 150,
  }),
  strCol({
    ident: 'effectiveToString',
    display: 'Effective To',
    sortOrder: 'asc',
    width: 150,
  }),

  modifierCol,
  modifiedDateCol,
]

const title = 'Unit Block Management'

const UnitBlock = ({ utilityNameMap, unitNameMap }) => {
  const [insertEvent, setInsertEvent] = useState(false)
  const headerWithFormatter = useMemo(
    _ =>
      headers.map(header =>
        header.ident === 'utility'
          ? {
              ...header,
              // ...toSelectionColProps(utilityNameMap),
              dataFormatter: ({ value }) =>
                `${value}` + ' - ' + `${utilityNameMap[value] || value}`,
              sortIndexGetter: ({ rowData }) =>
                utilityNameMap[rowData.utility] || rowData.utility,
            }
          : header.ident === 'unitId'
          ? {
              ...header,
              // choices: [],
              dataFormatter: ({ value, rowData }) =>
                `${rowData.unit}` + ' - ' + (unitNameMap[value] || value),
              sortIndexGetter: ({ rowData }) =>
                unitNameMap[rowData.unitId] || rowData.unitId,
            }
          : header
      ),
    [unitNameMap, utilityNameMap]
  )
  const InsertComp = ({ insertData, setInsertData, onAdd, onCancel }) => {
    return (
      <div
        style={{
          display: 'grid',
          gridTemplateColumns:
            '100px 300px 100px 150px 120px 200px 120px 200px min-content min-content min-content',
          gap: 10,
        }}
      >
        <Label>Utility / Unit :</Label>
        <UtilityUnitSelection
          style={{ gridColumnEnd: 'span 1' }}
          utility={insertData.utility}
          unit={insertData.unit}
          onUnitChange={value => {
            // setUtilityUnit(value)
            setInsertData({
              ...insertData,
              utility: value[0],
              unitId: value[1],
              unit: value[1].substr(3),
            })
          }}
        />
        <Label>Block Id :</Label>
        <Input
          value={insertData.blockId}
          onChange={e =>
            setInsertData({ ...insertData, blockId: e.target.value })
          }
          style={{ width: '100%' }}
          maxLength={6}
        />
        <Label>Effective From :</Label>
        <DatePicker
          style={{ minWidth: '120px' }}
          onChange={date =>
            setInsertData({
              ...insertData,
              effectiveFrom: date.format('YYYY-MM-DD'),
              effectiveFrom2: date,
              // transDate: date,
            })
          }
          value={insertData.effectiveFrom2}
          placeholder="Effective From"
          format="MM/DD/YYYY"
          allowClear={false}
        />
        <Label>Effective To :</Label>
        <DatePicker
          style={{ minWidth: '120px' }}
          onChange={date =>
            setInsertData({
              ...insertData,
              effectiveTo: date.format('YYYY-MM-DD'),
              effectiveTo2: date,
              // transDate: date,
            })
          }
          value={insertData.effectiveTo2}
          placeholder="Effective to"
          format="MM/DD/YYYY"
          allowClear={false}
        />
        <Button type="primary" onClick={() => onAdd(true)}>
          Add
        </Button>
        <Button type="primary" onClick={() => onAdd(false)}>
          Add & Hide
        </Button>
        <Button type="danger" onClick={onCancel}>
          Cancel
        </Button>
      </div>
    )
  }

  const modifySaveDataBeforeSave = saveData => {
    return saveData.map(s => {
      const to = s.effectiveToString
      if (to)
        return {
          ...s,
          effectiveTo: moment(to, 'MM/DD/YYYY').format('YYYY-MM-DD'),
        }
      return {
        ...s,
        effectiveTo: undefined,
      }
    })
  }

  return (
    <CommonScreen
      title={title}
      header={headerWithFormatter}
      saveTask={updateUnitBlock}
      retrieveTask={getUnitBlock}
      deleteTask={deleteUnitBlock}
      autoRetrieve
      sortOptions={headers}
      widthOffset={50}
      insertComp={insertEvent && InsertComp}
      insertCompHeight={50}
      onInsertEvent={b => setInsertEvent(b)}
      defaultInsertData={{
        effectiveFrom2: moment(),
        effectiveFrom: moment().format('YYYY-MM-DD'),
      }}
      modifySaveDataBeforeSave={modifySaveDataBeforeSave}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
})

export default connect(mapStateToProps)(UnitBlock)
